export default {
  login: "auth/login",
  passwordReset: "auth/forgot-password",
  setPassword: "auth/setPassword",
  password: "auth/reset-password",
  logout: "auth/logout",
  user: `auth/user`,
  verify: `auth/search`,
  sendOtp: `auth/resend-otp`,
  verifyOtp: `auth/verify-otp`,
  verifyToken: `auth/verifyVoterToken`,
  sendVoterToken: `auth/sendVoterToken`,
  register: "auth/register",
  linkedinLogin: "auth/login/linkedin-openid",
  socialLoginCallback: (provider) => `auth/${provider}/callback`,
};
